import { call, put, takeLatest } from "redux-saga/effects";
import { fetchUserProfileRequest, fetchUserProfileSuccess, fetchUserProfileFailure } from "../slice/userProfileSlice";
import { fetchUserProfileApi } from "@src/api/apiService"; // You need to implement this API call
import { getApiError } from "@src/utils/apiError";

export function* fetchUserProfile(): Generator<any, void, any> {
    try {
        const response = yield call(fetchUserProfileApi);
        yield put(fetchUserProfileSuccess(response.data));
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            fetchUserProfileFailure(
                apiError.message
            )
        );
    }
}

export function* userProfileSaga() {
    yield takeLatest(fetchUserProfileRequest.type, fetchUserProfile);
}
